import React, { useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { Toast } from 'primereact/toast';
import { useStoreState, useStoreActions } from 'easy-peasy';
import constants from '../constants/constants';
import { Divider } from 'primereact/divider';
import axiosInstance from '../constants/axiosInstance';
import { useHistory } from 'react-router-dom';
import { ProgressBar } from 'primereact/progressbar';
import GanttChartHod from './hodUser/GanttChartHod';
import { Chart } from 'primereact/chart';
import { saveAs } from 'file-saver';
import ExcelJS from "exceljs";
import html2canvas from "html2canvas";
import { Button } from "primereact/button";
// import OpenCompleted from '../images/openCompleted';

const Dashboard = () => {
    const toast = useRef(null);
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [records, setRecords] = useState();
    const [status, setStatus] = useState();
    const [progressRecords, setProgressRecords] = useState();
    const user = useStoreState((actions) => actions.loginModel.user);
    const setUserDashboardFilterProjects = useStoreActions((actions) => actions.projectModel.setUserDashboardFilterProjects);
    const userDashboardFilterProjects = useStoreState((actions) => actions.projectModel.userDashboardFilterProjects);
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});
    const [monthList, setMonthList] = useState();
    const [tasks, setTasks] = useState();
    const [searchText, setSearchText] = useState('');
    const filterProjects = useStoreState((actions) => actions.projectModel.filterProjects);
    const setEmployeeName = useStoreActions((actions) => actions.projectModel.setEmployeeName);
    const employeeName = useStoreState((actions) => actions.projectModel.employeeName);

    useEffect(() => {
        getSchedule()
        setUserDashboardFilterProjects(null);
        getProjects();
        getSubTaskStatus();
    }, []);

    const getSchedule = () => {
        setIsLoading(true);
        axiosInstance
            .get(constants.APQP_UPL.USER_DASHBOARD + "/" + user?.user?._id + "?" + `projectManager=&productionLocation=&client_id=&projectObject=`)
            .then((resp) => {
                setRecords(resp?.data?.data);
            })
            .catch((e) => console.error(e))
            .finally(() => {
                setIsLoading(false);
            });
    }

    const handleFilterProject = (value) => {
        const data = {
            cardValue: value,
        }
        setUserDashboardFilterProjects(data);
        history.replace("/app/us-projects");
    }

    const getProjects = () => {
        axiosInstance.get(constants.APQP_UPL.PROJECT_ASSIGNED_BY_USER_ID + user?.user?._id)
            .then((resp) => {
                setProgressRecords(resp?.data?.data);
            }).catch((e) => {
                console.error(e);
            }).finally(() => {
                setIsLoading(false);
            })
    }

    const getSubTaskStatus = () => {
        axiosInstance.get(constants.APQP_UPL.USER_PROGRESS_COMPLETION + user?.user?._id)
            .then((resp) => {
                setStatus(resp?.data?.data);
            }).catch((e) => {
                console.error(e);
            }).finally(() => {
                setIsLoading(false);
            })
    }


    useEffect(() => {
    const statusColorMap = {
        "In-Progress": "#EFAF1E", // Yellow
        "Completed": "#5DDE32", // Green
        "Hold": "#B1B1B1", // Grey
        "Open": "#", // Blue
    };
    
    const documentStyle = getComputedStyle(document.documentElement);
    const labels = status?.map(item => item.projectName);
    const datas = status?.map(item => parseFloat(item.completionPercentage));
    const backgroundColors = status?.map(item => statusColorMap[item.projectStatus] || "#B5E0F8"); // Default to light blue
    const textColor = documentStyle.getPropertyValue('--text-color');
    const data = {
        labels: labels,
        datasets: [
            {
                label: 'Completed Percentage',
                data: datas,
                fill: false,
                borderDash: [5, 5],
                tension: 0.4,
                borderColor: '#B4B4B4',
                backgroundColor: backgroundColors,
                pointBorderColor: backgroundColors,
                pointBackgroundColor: backgroundColors,
                borderWidth: 1,
                pointRadius: 5, // Increases the size of the points
                pointHoverRadius: 7, // Increases the size of points on hover
            },
        ],
    };

    const options = {
        maintainAspectRatio: false,
        aspectRatio: 0.8,
        plugins: {
            legend: {
                position: 'bottom', // Display legend at the bottom
                labels: {
                    color: textColor
                },
                display: false,
            },
        },
        scales: {
            x: {
                title: {
                    display: true, // Enable the label for X-axis
                    text: 'Project Names', // X-axis label text
                    color: "#212121", // Label color
                    font: {
                        size: 12, // Font size
                        weight: 600, // Font weight
                    },
                },
                grid: {
                    drawOnChartArea: false,
                },
            },
            y: {
                title: {
                    display: true, // Enable the label for Y-axis
                    text: 'Completion Percentage', // Y-axis label text
                    color: "#212121", // Label color
                    font: {
                        size: 12, // Font size
                        weight: 600, // Font weight
                    },
                },
                beginAtZero: true,
                max: 100,
                grid: {
                    drawOnChartArea: false,
                },
            },
        },
    };

    setChartData(data);
    setChartOptions(options);
}, [records, progressRecords]);

  // Helper function to format date to "MMM YYYY"
  const formatDateToMonth = (date) => {
    return date ? new Date(date).toLocaleString("en-US", { month: "long", year: "numeric" }) : '';
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Completed":
        return { argb: "26C10D" }; // Green
      // case "In-Progress":
      //   return { argb: "F3E900" }; // Yellow
      case "Open":
        return { argb: "88A1E3" }; // Red
      default:
        return { argb: "FFFFFF" }; // Transparent/White
    }
  };

  const generateMonthData = (start, end) => {
    const months = [];
    const current = new Date(start.getFullYear(), start.getMonth(), 1);
    while (current <= end) {
      months.push(current.toLocaleString("en-US", { month: "long", year: "numeric" }));
      current.setMonth(current.getMonth() + 1);
    }
    return months;
  };

    useEffect(() => {
        const taskItem = progressRecords?.filter((item) => {
          const projectManagerMatch = filterProjects?.PM ? item?.projectManager === filterProjects?.PM : true;
          const productionLocationNameMatch = filterProjects?.PL ? item?.productionLocation === filterProjects?.PL : true;
          const clientNameMatch = filterProjects?.CN ? item?.client_id?._id === filterProjects?.CN : true;
          const projectObjectNameMatch = filterProjects?.PO ? item?.projectObject === filterProjects?.PO : true;
          const projectName = item?.projectName?.toLowerCase()?.includes(searchText?.toLowerCase());
          const projectEndDateMatch = filterProjects?.YEAR ? item?.projectEndDate?.includes(filterProjects?.YEAR?.getFullYear()) : true;
  
          return projectManagerMatch && productionLocationNameMatch && projectObjectNameMatch && clientNameMatch && projectName && projectEndDateMatch
        })?.flatMap(item => ({
          projectName: item.projectName,
          list: item.taskHeader_id.map(taskHeader => {
            const subTasks = taskHeader.subTasks || [];
        
            return {
              headerTitle: taskHeader.headerTitle,
              subTasks: subTasks.map(subTask => ({
                subTaskName: subTask.subTaskName,
                startDate: subTask.startDate,
                endDate: subTask.endDate,
                subTaskStatus: subTask.subTaskStatus,
              })),
              startDate: subTasks.length 
                ? subTasks.reduce((minDate, subTask) => 
                    subTask.startDate && (!minDate || new Date(subTask.startDate) < new Date(minDate)) 
                      ? subTask.startDate 
                      : minDate, null) 
                : null,
              endDate: subTasks.length 
                ? subTasks.reduce((maxDate, subTask) => 
                    subTask.endDate && (!maxDate || new Date(subTask.endDate) > new Date(maxDate)) 
                      ? subTask.endDate 
                      : maxDate, null) 
                : null,
              status: subTasks.every(subTask => subTask.subTaskStatus === "Open")
                ? "Open"
                : subTasks.every(subTask => subTask.subTaskStatus === "Completed")
                  ? "Completed"
                  : "In-Progress",
            };
          }),
        }));
  
        // Collect all valid dates from the task items
        const allDates = (taskItem ?? []).flatMap(project =>
          project.list.flatMap(task => task.startDate && task.endDate && [
            new Date(task.startDate),
            new Date(task.endDate)
          ]
          )).filter((item) => item);
  
        const minDate = new Date(Math.min(...allDates.map(date => date.getTime())));
        const maxDate = new Date(Math.max(...allDates.map(date => date.getTime())));
  
        const monthData = generateMonthData(minDate, maxDate);
        setMonthList(monthData);
        setTasks(taskItem);
      
    }, [progressRecords, searchText]);

    const exportExcelDashboard = async () => {
        setTimeout(async () => {
            try {
                const workbook = new ExcelJS.Workbook();

                // Sheet 1: Project Completion (Graph)
                const completionSheet = workbook.addWorksheet("Project Completion");

                // Capture the chart as an image
                const chartElement = document.querySelector(".chart-container");
                if (!chartElement) {
                    console.error("Chart not found");
                    return;
                }

                const canvas = await html2canvas(chartElement);
                const imageData = canvas.toDataURL("image/png");

                // Add image to Excel
                const imageId = workbook.addImage({
                    base64: imageData,
                    extension: "png",
                });

                completionSheet.addImage(imageId, {
                    tl: { col: 1, row: 1 },
                    ext: { width: 800, height: 450 },
                });

                // ✅ Sheet 3: Gantt Chart
                const worksheet = workbook.addWorksheet("Gantt Chart");


                worksheet.getCell("A1").value = `User: ${employeeName}`;
                worksheet.getCell("A1").font = { bold: true, size: 12 };
                worksheet.getCell("A1").alignment = { vertical: "middle", horizontal: "left" };

                worksheet.getCell("D1").value = "■ Open";
                worksheet.getCell("D1").font = {
                    name: "Calibri",
                    size: 14,
                    bold: true,
                    color: { argb: "88A1E3" }, // light blue
                };

                worksheet.getCell("E1").value = "■ Completed";
                worksheet.getCell("E1").font = {
                    name: "Calibri",
                    size: 14,
                    bold: true,
                    color: { argb: "FF26C10D" }, // green
                };

                // === Row 2: Empty spacer ===
                worksheet.addRow([]);

                // === Row 3: Column headers ===
                const columnHeaders = [
                    "Subtask Name",
                    "Start Date",
                    "End Date",
                    ...monthList,
                ];
                worksheet.getRow(3).values = columnHeaders;

                // === Column widths ===
                worksheet.getColumn(1).width = 40; // Subtask Name
                worksheet.getColumn(2).width = 15; // Start Date
                worksheet.getColumn(3).width = 15; // End Date
                monthList.forEach((_, index) => {
                    worksheet.getColumn(4 + index).width = 15;
                });

                const headerRow = worksheet.getRow(3);
                headerRow.font = { bold: true, size: 12 };
                headerRow.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "D3D3D3" },
                };

                // === ROW 4+: Data Rows ===
                let currentRow = 4;

                tasks.forEach((task) => {
                    // Project name row (merged)
                    const projectRowIndex = currentRow++;
                    worksheet.addRow({});
                    worksheet.mergeCells(`A${projectRowIndex}:C${projectRowIndex}`);
                    worksheet.getCell(`A${projectRowIndex}`).value = task.projectName;
                    worksheet.getCell(`A${projectRowIndex}`).font = { bold: true, size: 13 };
                    worksheet.getCell(`A${projectRowIndex}`).alignment = { vertical: "middle", horizontal: "left" };

                    // Subtask rows
                    task.list?.forEach((group) => {
                        group.subTasks
                            ?.filter((subTask) => ["Open", "Completed"].includes(subTask.subTaskStatus))
                            .forEach((subTask) => {
                                const row = worksheet.getRow(currentRow++);
                                row.getCell(1).value = subTask.subTaskName;
                                row.getCell(2).value = formatDateToMonth(subTask.startDate);
                                row.getCell(3).value = formatDateToMonth(subTask.endDate);

                                // Border color by status
                                const borderColor =
                                    subTask.subTaskStatus === "Completed" ? "26C10D" :
                                        subTask.subTaskStatus === "Open" ? "88A1E3" : "FFFFFF";

                                row.getCell(1).border = {
                                    left: { style: "thick", color: { argb: borderColor } },
                                };

                                // Fill cells in month range
                                const startIndex = monthList.findIndex(
                                    (month) => month === formatDateToMonth(subTask.startDate)
                                );
                                const endIndex = monthList.findIndex(
                                    (month) => month === formatDateToMonth(subTask.endDate)
                                );

                                const monthStartIndex = 4; // D column
                                monthList.forEach((_, i) => {
                                    if (i >= startIndex && i <= endIndex) {
                                        const cell = row.getCell(monthStartIndex + i);
                                        cell.fill = {
                                            type: "pattern",
                                            pattern: "solid",
                                            fgColor: getStatusColor(subTask.subTaskStatus),
                                        };
                                    }
                                });
                            });
                    });
                });

                //Save the Excel File
                const buffer = await workbook.xlsx.writeBuffer();
                saveAs(new Blob([buffer], { type: "application/octet-stream" }), "Dashboard_Report.xlsx");

            } catch (error) {
                console.error("Error exporting Excel:", error);
            }
        }, 100);
    };


    return (
        <>
            <Toast ref={toast} />
            <div className="flex align-items-center justify-content-between">
                <div>
                    <h3 className="PS-title m-0">Dashboard</h3>
                </div>
                <div>
                    <Button className="btn-black mx-2" label="Download" onClick={exportExcelDashboard} />
                </div>
            </div>
            {isLoading ?
                <ProgressBar mode="indeterminate" style={{ height: '2px' }} className='my-3'></ProgressBar>
                : <Divider />}
            <div className='grid mt-3' >
                <div className='col-12 md:col-6 lg:col-3'>
                    <div onClick={() => handleFilterProject("")} className='flex justify-content-between hod-Project'>
                        <div style={{ width: '50%' }}>
                            <div className='small-cards' >
                                <h2 className='dash_pro_stats_value'>{records?.totalTasks}</h2>
                                <h5 className='dash_pro_stats_title'>Total Task</h5>
                            </div>
                        </div>
                        <div className='hod-dash-image' style={{ width: '50%' }}>
                        </div>
                    </div>
                </div>
                <div className='col-12 md:col-6 lg:col-3'>
                    <div onClick={() => handleFilterProject("In-Progress")} className='hod-Project flex  justify-content-between'>
                        <div style={{ width: '50%' }}>
                            <div className='small-cards'>
                                <h2 className='dash_pro_stats_value'>{records?.onGoingTasks}</h2>
                                <h5 className='dash_pro_stats_title mb-0'>On Going Task</h5>
                            </div>
                        </div>

                        <div className='hod-dash2-image' style={{ width: '50%' }}>
                            {/* <img src={Icon1} alt='icon1' /> */}
                        </div>
                    </div>
                </div>
                <div className='col-12 md:col-6 lg:col-3'>
                    <div onClick={() => handleFilterProject("Completed")} className='hod-Project flex justify-content-between'>
                        <div style={{ width: '50%' }}>
                            <div className='small-cards'>
                                <h2 className='dash_pro_stats_value '>{records?.completedTasks}</h2>
                                <h5 className='dash_pro_stats_title mb-0'>Completed Task</h5>
                            </div>
                        </div>
                        <div className='hod-dash3-image' style={{ width: '50%' }}>
                            {/* <img src={Group} alt='group' /> */}
                        </div>
                    </div>
                </div>
                <div className='col-12 md:col-6 lg:col-3'>
                    <div onClick={() => handleFilterProject("Delayed")} className='hod-Project flex justify-content-between'>
                        <div style={{ width: '50%' }}>
                            <div className='small-cards'>
                                <h2 className='dash_pro_stats_value '>{records?.openTasks}</h2>
                                <h5 className='dash_pro_stats_title mb-0'>Open Task</h5>
                            </div>
                        </div>
                        <div className='hod-dash4-image' style={{ width: '50%' }}>
                            {/* <img src={Group} alt='group' /> */}
                        </div>
                    </div>
                </div>
            </div>

            <div className="card mt-5">
                <h3 className="PS-title m-0">Project Completion</h3>
                <Divider />
                <div className='flex justify-content-end align-items-center mb-3'>
                    <div className='on-going-projects'></div><span className='status'>On Going Projects</span>
                    <div className='completed-projects'></div><span className='status'>Completed Projects</span>
                    <div className='hold-projects'></div><span className='status'>Hold Projects</span>
                    {/* <div className='open-projects'></div><span className='status'>Open</span> */}
                </div>


                <div className='flex justify-content-center chart-container'>
                    <Chart type="line" data={chartData} options={chartOptions} className="w-full" />
                </div>
            </div>

            <GanttChartHod toGantt={progressRecords} />
        </>
    );
}

export default Dashboard;